var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPyramids(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.32111 7.84534C7.27386 7.89762 7.23074 7.95642 7.19279 8.02175L1.14597 18.4284C0.74676 19.1154 1.21348 20 1.97519 20H10.1903L7.32111 7.84534Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6734 20H14.0688C14.8305 20 15.2973 19.1154 14.898 18.4284L8.87976 8.0708L11.6514 19.8124C11.6662 19.8752 11.6733 19.9381 11.6734 20Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6801 4C14.5904 4.08409 14.513 4.18893 14.4537 4.31453L11.7454 10.0511L16.142 17.6178C16.5932 18.3942 16.602 19.2716 16.3002 20H17.9848L14.6801 4Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4626 20H22.0251C22.7489 20 23.2196 19.1933 22.896 18.5077L16.2747 4.48267L19.4456 19.8347C19.457 19.8901 19.4625 19.9455 19.4626 20Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPyramids);
export default __webpack_public_path__ + "static/media/pyramids.16b6e585bfcfe98e56a0703f549e74b6.svg";
export { ForwardRef as ReactComponent };